import { ScrollText, Lock, RefreshCw } from "lucide-react";
const pilares = [{
  icon: ScrollText,
  title: "Cumplimiento normativo",
  desc: "Alineado con la LFPIORPI reformada (julio 2025), las Reglas de Carácter General, y los estándares del GAFI. Diseñado específicamente para el marco regulatorio mexicano."
}, {
  icon: Lock,
  title: "Seguridad de datos",
  desc: "Cifrado de extremo a extremo, autenticación multifactor, y almacenamiento seguro de documentos. Tus expedientes protegidos como lo exige la ley."
}, {
  icon: RefreshCw,
  title: "Actualización continua",
  desc: "Cuando la ley cambie, Notalia se actualiza. Listas PEP/OFAC actualizadas, formatos de reporte al día, y nuevas obligaciones incorporadas automáticamente."
}];
export default function ConfianzaCredibilidad() {
  return <section data-section-id="REEMPLAZAR" id="confianza" className="bg-card text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl max-w-3xl">
            Construido sobre la ley,{" "}
            <span className="text-primary font-mono">respaldado por tecnología</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {pilares.map((pilar, i) => {
          const Icon = pilar.icon;
          return <div key={pilar.title} data-index={i} className="p-6 md:p-8 rounded-lg bg-background border border-border hover:border-primary/40 transition-colors text-center">
                <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center mb-5 mx-auto">
                  <Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-xl font-bold text-white mb-3">{pilar.title}</h3>
                <p className="font-default text-sm text-slate-400 leading-relaxed">{pilar.desc}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}